import i18n from '@/utils/i18n';
import { ChatProspectStage } from '@/types';
import { getProspectStageVisual } from '@/experiences/sales-portal/domain/prospects/blocs/utils/prospect-stage-visuals';
import type { ProspectStageVisual } from '@/experiences/sales-portal/domain/prospects/blocs/utils/prospect-stage-visuals';

export interface ProspectStageOption extends ProspectStageVisual {
  label: string;
  stage: ChatProspectStage;
}

export const LOST_STAGE_DOT_COLOR = '$iconNegativePrimary';

const STAGE_LABEL_KEYS: Record<ChatProspectStage, string> = {
  [ChatProspectStage.Cold]: 'sales_portal.prospect_detail.stage.cold',
  [ChatProspectStage.Discovery]: 'sales_portal.prospect_detail.stage.discovery',
  [ChatProspectStage.Engaged]: 'sales_portal.prospect_detail.stage.engaged',
  [ChatProspectStage.New]: 'sales_portal.prospect_detail.stage.new',
  [ChatProspectStage.Quote]: 'sales_portal.prospect_detail.stage.quote',
  [ChatProspectStage.Won]: 'sales_portal.prospect_detail.stage.won',
};

const STAGE_ORDER: ChatProspectStage[] = [
  ChatProspectStage.Cold,
  ChatProspectStage.Discovery,
  ChatProspectStage.Engaged,
  ChatProspectStage.Quote,
  ChatProspectStage.Won,
];

export const getProspectStageOption = (
  stage: ChatProspectStage,
): ProspectStageOption => {
  const labelKey = STAGE_LABEL_KEYS[stage];

  return {
    ...getProspectStageVisual(stage),
    label: labelKey ? i18n.t(labelKey) : stage,
    stage,
  };
};

export const buildProspectStageOptions = (): ProspectStageOption[] =>
  STAGE_ORDER.map(getProspectStageOption);
